export const redirectTo = (history, path) => {

    window.setTimeout(() => {
        history.push(path);
     }, 950)
};

export const redirectToScaDevice = (props, paymentInfo) => {
    
    const { history, language } = props;
    var path = ""

    if (paymentInfo.appToAppScaDevice) {
        path = `/${language}/luxtrust/${paymentInfo.appToAppScaDevice}`;
    } else {
        path = `/${language}/device`;
    }

    window.setTimeout(() => {
        history.push(path);
     }, 950)
};

export default redirectTo